import React from "react";

const RateResponseSystemMessage = () => (
    <li className="system-message message-rate-response">
        <p className="body">{i18n.t("rtm.text.rate_your_conversation")}</p>
    </li>
);

export default RateResponseSystemMessage;
